import { Outlet } from "react-router-dom";
import { BottomNav } from "./BottomNav";
import { HeaderProvider, useHeaderContext } from "@/contexts/HeaderContext";
import { useHideOnScroll } from "@/hooks/useHideOnScroll";

// Fixed heights - iOS standard navigation bar is 44px
const HEADER_CONTENT_HEIGHT = 44;
const BOTTOMNAV_HEIGHT = 56;

/**
 * AppShell - Master layout controller for mobile-first native app
 * 
 * ARCHITECTURE (Capacitor/iOS):
 * - StatusBar: Native (controlled by Capacitor, overlaysWebView: true)
 * - Header: position: fixed, top: 0, includes safe-area padding
 * - Main: paddingTop equals header total height (content + safe-area)
 * - BottomNav: position: fixed, bottom: 0, includes safe-area padding
 * 
 * IMPORTANT: Header component itself has position: fixed via data-fixed-header
 * We only animate the wrapper's transform for pull-to-reveal behavior
 * 
 * SCROLL BEHAVIOR (iOS Native):
 * - Scroll ↓: Header slides out (translateY -100%)
 * - Scroll ↑: Header slides in (pull-to-reveal)
 * - Top of page: Header always visible
 * - Bottom Nav: ALWAYS fixed, never moves
 */

const AppShellContent = () => {
  const { headerElement } = useHeaderContext();
  const { isHeaderVisible } = useHideOnScroll({ threshold: 10 });
  
  return (
    <>
      {/* 
        ✅ CORREÇÃO iOS: Header wrapper no nível RAIZ com position: fixed
        - O container aplica safe-area-inset-top via CSS [data-header-container]
        - O header interno usa height: 44px fixa (padrão iOS)
        - transform para animação pull-to-reveal
      */}
      <div
        style={{
          // Animação pull-to-reveal
          transform: isHeaderVisible ? 'translate3d(0,0,0)' : 'translate3d(0,-100%,0)',
          WebkitTransform: isHeaderVisible ? 'translate3d(0,0,0)' : 'translate3d(0,-100%,0)',
          transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        }}
        data-header-container="true"
      >
        {headerElement}
      </div>

      {/* Container principal do conteúdo */}
      <div 
        style={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100dvh',
          paddingBottom: `calc(${BOTTOMNAV_HEIGHT}px + env(safe-area-inset-bottom, 0px))`,
        }}
      >
        {/* Main scrollable content */}
        <main 
          id="app-main-content"
          style={{
            flex: 1,
            paddingTop: `calc(${HEADER_CONTENT_HEIGHT}px + env(safe-area-inset-top, 0px))`,
          }}
        >
          <Outlet />
        </main>
      </div>
      
      {/* BottomNav FORA do container */}
      <BottomNav />
    </>
  );
};

export const AppShell = () => (
  <HeaderProvider>
    <AppShellContent />
  </HeaderProvider>
);
